import { i18next } from '@frontend/i18n';

export const BULK_CREATE_STEPS: Record<
  'VALIDATE_USERS' | 'SEND_SMS' | 'SELECT_TEMPLATE' | 'NON_SELECTABLE_USERS',
  { id: string; title: string }
> = {
  VALIDATE_USERS: {
    id: 'validate-users',
    title: i18next.t('Selections', { ns: 'payments' }),
  },
  SEND_SMS: {
    id: 'send-sms',
    title: i18next.t('Share in Message', { ns: 'payments' }),
  },
  SELECT_TEMPLATE: {
    id: 'select-template',
    title: i18next.t('Select a Payments Template', { ns: 'payments' }),
  },
  NON_SELECTABLE_USERS: {
    id: 'non-selectable-users',
    title: i18next.t('Non-Selectable Users', { ns: 'payments' }),
  },
};
